import Mgrs, { LatLon } from 'geodesy/mgrs.js'
import { Loader } from '@googlemaps/js-api-loader'
import { GOOGLE_MAPS_API_KEY } from '@/config'
import store from '@/store'

/* eslint-disable no-undef */
const googleMaps = function() {
  return new Promise(resolve => {
    const loader = new Loader({
      apiKey: GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: ['places']
    })

    loader.load().then(() => {
      resolve(google.maps)
    })
  })
}

const getLatLng = function(mgrs) {
  const grid = parseInt(mgrs)
  mgrs = grid < 10 && mgrs[0] != '0' ? `0${mgrs}` : mgrs
  mgrs = mgrs.replace(/\s*/g, '')
  const p = Mgrs.parse(mgrs)
  const latlng = p.toUtm().toLatLon()
  return { latitude: latlng.lat, longitude: latlng.lng }
}

const getMgrs = function(latlng) {
  const p = new LatLon(latlng.latitude, latlng.longitude)
  return p
    .toUtm()
    .toMgrs()
    .toString(6)
}

const isMgrs = function(value) {
  value = value.replace(/\s*/g, '').replace(/^0+/, '')
  const re = /^\d{1,2}[^ABIOYZabioyz][A-Za-z]{2}([0-9][0-9])+$/
  return re.test(value)
}

const isLatitude = function(value) {
  const re = /^-?((90\/[0]{0,}\/[0]{0,}$)|([1-8]?\d))(\/|:| )(([1-5]?\d))(\/|:| )[1-5]?\d(\.\d{0,})?$/
  return re.test(value)
}

const isLongitude = function(value) {
  const re = /^-?((180(\/|:| )0(\/|:| )0((\.0{0,})?))|(([1]?[1-7]\d)|\d?\d)(\/|:| )([1-5]?\d)(\/|:| )[1-5]?\d(\.\d{0,})?$)/
  return re.test(value)
}

const isLatLong = function(value) {
  if (!value) {
    return false
  }
  try {
    return LatLon.parse(value)
  } catch {
    return false
  }
}

const browserLocation = async function() {
  return new Promise(resolve => {
    if (!('geolocation' in navigator)) {
      resolve(null)
    }

    navigator.geolocation.getCurrentPosition(
      pos => {
        resolve(pos.coords)
      },
      (e) => {
        console.log('browser geolocation is not available', e)
        resolve(null)
      },
      { timeout: 5000, maximumAge: 60000, enableHighAccuracy: true }
    )
  })
}

const knownLocations = {
  hawaii: {
    latitude: 21.4097967,
    longitude: -157.9160812,
    mgrs: '04Q FJ 128 584'
  },
  ukraine: {
    latitude: 50.4501,
    longitude: 30.5234,
    mgrs: '46Q JF 064 064'
  },
  niger: {
    latitude: 13.650718860017589,
    longitude: 2.058192752301693,
    mgrs: '31P DQ 557 733'
  }
}

const defaultLocation = () => {
  if(store.getters['theme/location']) {
    return { ... store.getters['theme/location'] }
  }

  return knownLocations.hawaii
}

const zoom = 10

const imagePath = '/images/maps'

export default {
  defaultLocation,
  browserLocation,
  getLatLng,
  getMgrs,
  googleMaps,
  imagePath,
  isLatitude,
  isLongitude,
  isLatLong,
  isMgrs,
  zoom
}
